module.exports = __webpack_public_path__ + "img/instagram-purple.938e7dbc.png";